import { render, staticRenderFns } from "./LayoutList.vue?vue&type=template&id=6d6b795c&scoped=true&"
import script from "./LayoutList.vue?vue&type=script&lang=js&"
export * from "./LayoutList.vue?vue&type=script&lang=js&"
import style0 from "./LayoutList.vue?vue&type=style&index=0&id=6d6b795c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6b795c",
  null
  
)

export default component.exports